import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';
import { location } from '../../interfaces/AppConfiguration';

type GeoLocationActionTypes = {
    type: string;
    payload: location;
};

const geoLocationSlice = createSlice({
    name: 'GeoLocation',
    initialState: initialState.location,
    reducers: {
        geolocationInitialize: (state: location, action: GeoLocationActionTypes) => {
            state = action.payload;
            return state;
        },
    },
});

export const { geolocationInitialize } = geoLocationSlice.actions;

export default geoLocationSlice.reducer;
